export default "__VITE_ASSET__25d5dce9__"